import { render, staticRenderFns } from "./surrenderAdd.vue?vue&type=template&id=7eae274f&scoped=true&"
import script from "./surrenderAdd.vue?vue&type=script&lang=js&"
export * from "./surrenderAdd.vue?vue&type=script&lang=js&"
import style0 from "./surrenderAdd.vue?vue&type=style&index=0&id=7eae274f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eae274f",
  null
  
)

export default component.exports